import { ColDef, ColGroupDef } from "ag-grid-community";

export const useTableData = () => {
	const formatLength = (lengthInInches: number | null | undefined): string => {
		if (lengthInInches === null || lengthInInches === undefined) return "";
		const feet = Math.floor(lengthInInches / 12);
		const inches = lengthInInches % 12;
		return `${feet} ft ${inches} in`;
	};

	const columns: ColGroupDef[] = [
		{
			headerName: "Production",
			children: [
				{
					field: "Length",
					headerName: "Length",
					flex: 1,
					minWidth: 75,
					valueFormatter: (params) => formatLength(params.value),
					cellStyle: {
						textAlign: "center",
					},
				},
				{
					field: "Pieces",
					headerName: "Pieces",
					flex: 1,
					minWidth: 70,
					cellStyle: {
						textAlign: "center",
					},
				},
				{
					field: "SectionName",
					headerName: "Section",
					flex: 1,
					minWidth: 96,
					cellStyle: {
						textAlign: "right",
					},
				},
			],
		},
	];

	const defaultColDef: ColDef = {
		filter: false,
		floatingFilter: false,
		sortable: false,
		resizable: false,
		editable: false,
		suppressHeaderMenuButton: true,
	};

	return { columns, defaultColDef };
};
